import React from "react";
import { useNavigate } from "react-router-dom";
import Menu, { Item } from "devextreme-react/menu";
import { useMediaQuery } from "react-responsive";
import "./HeaderNavigation.scss";

const HeaderNavigation = ({ closeNav }) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const handleMenuClick = (e) => {
    const { itemData } = e;
    if (itemData.path) {
      navigate(itemData.path);
      if (closeNav) {
        closeNav(); 
      }
    }
  };

  const userDetails = localStorage.getItem("userDetails");
  const userRole = userDetails ? JSON.parse(userDetails) : null;

  return (
    <Menu
      onItemClick={handleMenuClick}
      orientation={isMobile ? "vertical" : "horizontal"}
    >
      <Item
        disabled={!userRole || userRole.role !== "admin"}
        text="Orders"
        path="/orders"
        cssClass="disabled-tab"
      />
      <Item
        disabled={!userRole || userRole.role !== "admin"}
        text="Inventory"
        path="/inventory"
        cssClass="disabled-tab"
      />
      <Item
        disabled={!userRole || userRole.role !== "admin"}
        text="Master Data"
        path="/masterdata"
        cssClass="disabled-tab"
      />
      <Item
        disabled={!userRole || userRole.role !== "admin"}
        text="Traceability"
        path="/traceability"
        cssClass="disabled-tab"
      />
      <Item
        disabled={false}
        text="Quality"
        path="/quality"
        selected={true}
      />
    </Menu>
  );
};

export default HeaderNavigation;
